import type { Me } from '@/shared/types/domain'

import { useAuth } from './auth-context'
import { useMe } from './use-me'

export type SessionStatus = 'loading' | 'anonymous' | 'authenticated'

export interface Session {
  status: SessionStatus
  me: Me | null
  error: unknown
}

/**
 * La sesion completa en un solo hook: Firebase dice si hay usuario, `GET /me`
 * dice quien es y que rol tiene.
 *
 * Los guards consumen ESTO y no los dos por separado. Mientras `/me` esta en
 * vuelo el estado sigue siendo `loading`: si devolvieramos `authenticated` sin
 * rol, `RequireRole` mandaria a todo el mundo a `/portal` durante un frame.
 */
export function useSession(): Session {
  const { status } = useAuth()
  const { data, isPending, error } = useMe()

  if (status === 'loading') return { status: 'loading', me: null, error: null }
  if (status === 'anonymous') return { status: 'anonymous', me: null, error: null }

  if (isPending) return { status: 'loading', me: null, error: null }
  if (!data) return { status: 'anonymous', me: null, error }

  return { status: 'authenticated', me: data, error: null }
}
